// const BASE_URL = "http://192.168.20.2:5002/node_api/";
// const BASE_URL = "http://192.168.21.19:5000/node_api/";



//demo
// const BASE_URL = "https://jon.admin.iossmlm.com/node_api/";

//live
const BASE_URL = "https://admin.algomoneo.com/node_api/";

const DEFAULT_KEY = 'j%z4h*^D-jh75Y!jF-S(Sjch4^7-5h!h!A'
const PAYPAL_CLIENT_ID = "Ad077-Gx8stGcfWQYawBiQUc4UbKWIRIg_PK4lHL4pzHR-uOPMz2vCk_jQ8QU9pcEw0j8U3UYDrEUS75"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
